import React, { useState } from 'react'
import { Card, CardContent } from '../../ui/card'
import { Button } from '../../ui/button'
import { Label } from '../../ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { extractErrorMessage } from '@/common/extractErrorMessage'
import { useApplicationStore } from '../../../stores/useApplicationStore'
import ReportEndpoints from '../../../endpoints/ReportEndpoints'
import { ReportViewer, useReportViewer } from '../ReportViewer'
import { rootUrl } from '../reportShared'

export const UserAccessByClientPage: React.FC = () => {
  const { clients } = useApplicationStore()
  const { viewerProps, openReport, generating, setGenerating } = useReportViewer()

  const [clientId, setClientId] = useState<string>('')

  const generate = async () => {
    setGenerating(true)
    try {
      const res = await ReportEndpoints.getIdentityAccessByClientReport({
        clientId: parseInt(clientId), rootUrl,
      })
      openReport('User Access by Client', res, parseInt(clientId))
    } catch (error) { toast.error(extractErrorMessage(error, 'Failed to generate report')) }
    finally { setGenerating(false) }
  }

  return (
    <>
      <Card className="max-w-3xl">
        <CardContent className="pt-6 space-y-4">
          <div className="space-y-2">
            <Label>Client *</Label>
            <Select value={clientId} onValueChange={setClientId}>
              <SelectTrigger><SelectValue placeholder="Select a client" /></SelectTrigger>
              <SelectContent>
                {clients.filter((c) => !c.dateArchived).map((c) => (
                  <SelectItem key={c.id} value={c.id.toString()}>{c.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button onClick={generate} disabled={generating || !clientId}>
            {generating ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Generating...</> : 'Generate Report'}
          </Button>
        </CardContent>
      </Card>
      <ReportViewer {...viewerProps} />
    </>
  )
}
